// extracted by mini-css-extract-plugin
export var addButton = "_jp-0";
export var border = "_jp-8";
export var check = "_jp-h";
export var danger = "_jp-6";
export var dropdownContainer = "_jp-1";
export var editModalBody = "_jp-j";
export var footerContainer = "_jp-i";
export var fullWidth = "_jp-a";
export var hide = "_jp-9";
export var icon = "_jp-3";
export var input = "_jp-7";
export var inputFlex = "_jp-b";
export var inputWrapper = "_jp-c";
export var manualFocus = "_jp-5";
export var optionButton = "_jp-4";
export var pillWrapper = "_jp-e";
export var pointer = "_jp-2";
export var showOverflow = "_jp-f";
export var tagsFlex = "_jp-d";
export var xButton = "_jp-g";